import { COUNTRY_ISO_MAPPING } from '../../Data/Country';
import { setPhoneNumberCountryCode } from '../../Lib/redux/slices/formConfig';
import { setLegalStatement } from '../../Lib/redux/slices/legalStatement';
import { isAnyPhoneNumberQuestionFilled } from '../__helpers__/component.helpers';

export const getOptionAnswerIdByText = (text, options) => {
  return options.filter((option) => text === option.value)[0].id;
};

export const removeDefaultOption = (options) => {
  let defaultOptionValue;
  const optionsWithoutDefault = options.filter((option) => {
    if (option.id === 'default_select_text') {
      defaultOptionValue = option.value;
      return false;
    }
    return true;
  });

  return [defaultOptionValue, optionsWithoutDefault];
};

export const getSelectedOptionId = (value, options) => {
  const selectedOption = options.find((option) => option.value === value);
  return selectedOption.id;
};

export const getSelectedOptionFilterValue = (value, options) => {
  const selectedOption = options.find((option) => option.value === value);
  return selectedOption.key;
};

const getISOCountyCode = (countrySelection) => {
  return COUNTRY_ISO_MAPPING[countrySelection];
};

export const updatePhoneNumberCountryCodeFollowingCountrySelection = ({
  optionValue,
  options,
  dispatch,
  components,
  countryCode,
}) => {
  if (isAnyPhoneNumberQuestionFilled(components)) return;

  const countrySelected = getSelectedOptionFilterValue(optionValue, options);
  const countryIsoCode = getISOCountyCode(countrySelected);

  dispatch(
    setPhoneNumberCountryCode({
      phoneNumberCountryCode: countryIsoCode,
    })
  );
  if (countryCode !== 'US') {
    // We don't re-request a statement for US forms, but for others, here we invalidate the legalStatement so a new one is requested in LegalStatement
    dispatch(setLegalStatement({ statement: null }));
  }
};
